import { createAsyncThunk } from '@reduxjs/toolkit'
import { ThunkConfig } from '../../redux/store'
import { Simulation } from '../models/Simulation'
import { SimulationResult } from '../models/SimulationResult'

export const executeSimulation = createAsyncThunk<
  SimulationResult,
  Simulation,
  ThunkConfig
>('simulation/executeSimulation', async (simulation, { extra }) => {
  const simulationResult = await extra.simulationGateway.fetchSimulationResult(
    simulation
  )
  return simulationResult
})
